import type { LeadMagnet } from "./leadMagnets";

// German lead magnet copy. Manually polished to a consistent informal "du" tone.
// When regenerating via scripts/translate-leadmagnets.ts, keep the "du" register.
export const leadMagnets_de: LeadMagnet[] = [
  {
    "slug": "build-your-own-tool-instead-of-saas",
    "eyebrow": "// own_it",
    "title": "Dein Tool gehört dir. [[Hör auf, dein Geschäft zu mieten.]]",
    "subtitle": "Jeden Monat zahlst du für SaaS, das du nicht kontrollierst — dessen Roadmap, Preiserhöhungen, Beschränkungen. Wir entwickeln Software, die komplett dir gehört: maßgeschneidert auf deine Arbeitsweise, frei erweiterbar und für immer deine.",
    "metaTitle": "Entwickle dein eigenes Tool, statt für SaaS zu zahlen | DevCore",
    "metaDescription": "Müde von SaaS-Limits, Pro-Platz-Preisen und fremden Roadmaps? DevCore entwickelt maßgeschneiderte Software, die dir gehört – flexibel, skalierbar und auf dein Unternehmen zugeschnitten.",
    "stats": [
      {
        "value": "100%",
        "label": "Eigentum an Code & Daten"
      },
      {
        "value": "0",
        "label": "Pro-Platz-Gebühren beim Wachstum"
      },
      {
        "value": "∞",
        "label": "Funktionen, die du hinzufügen kannst"
      }
    ],
    "problemKicker": "// the_trap",
    "problemTitle": "SaaS wirkt günstig — bis es dein Geschäft besitzt",
    "problemBody": "Standard-Tools sind anfangs praktisch und kontrollieren dich am Ende. Du verbiegst deine Prozesse, um zur Software zu passen, zahlst mehr, je mehr Leute dazukommen, und wartest auf Funktionen, die nie erscheinen. Das Abo endet nie, und dir gehört nie etwas.",
    "problemPoints": [
      "Pro-Platz-Preise, die dich für Wachstum bestrafen",
      "Kritische Funktionen stecken in einer Roadmap fest, die du nicht beeinflussen kannst",
      "Deine Daten sind in der Plattform eines anderen eingesperrt",
      "Workarounds, Tabellen und Notlösungen, um Lücken zu füllen",
      "Überraschende Preiserhöhungen ohne Alternativen"
    ],
    "pillarsKicker": "// why_own",
    "pillarsTitle": "Was dir Eigentum wirklich bringt",
    "pillars": [
      {
        "icon": "Lock",
        "title": "Echtes Eigentum",
        "body": "Dir gehören der Code, die Daten und die Infrastruktur. Keine Anbieterbindung, keine Plattform, die dir den Boden unter den Füßen wegziehen kann, kein jährliches Lösegeld, um weiterarbeiten zu dürfen."
      },
      {
        "icon": "SlidersHorizontal",
        "title": "Um dich herum gebaut",
        "body": "Die Software passt sich deinem exakten Workflow an – nicht einem generischen Durchschnitt aller anderen. Jeder Bildschirm, jedes Feld und jede Regel spiegelt wider, wie dein Team wirklich arbeitet."
      },
      {
        "icon": "TrendingUp",
        "title": "Skaliert kostenlos",
        "body": "Ob 5 Nutzer oder 500 – deine Kosten explodieren nicht. Du zahlst für Entwicklung und Hosting, niemals eine Steuer auf jeden neuen Arbeitsplatz."
      },
      {
        "icon": "Puzzle",
        "title": "Endlos anpassbar",
        "body": "Neue Idee am Montag, live bis Freitag. Dein Tool ändert sich, wenn sich dein Geschäft ändert, statt auf die Warteschlange eines Anbieters zu warten."
      }
    ],
    "compareKicker": "// side_by_side",
    "compareTitle": "SaaS mieten vs. dein Tool besitzen",
    "compareLeftLabel": "Generisches SaaS",
    "compareRightLabel": "Dein individuelles Tool",
    "compareRows": [
      {
        "label": "Preise",
        "left": "Pro Platz, für immer",
        "right": "Einmal bauen, besitzen"
      },
      {
        "label": "Passform",
        "left": "Du passt dich an",
        "right": "Es passt sich dir an"
      },
      {
        "label": "Roadmap",
        "left": "Ein anderer entscheidet",
        "right": "Du entscheidest"
      },
      {
        "label": "Daten",
        "left": "In deren Cloud gesperrt",
        "right": "Deine, überall"
      },
      {
        "label": "Skalierungskosten",
        "left": "Wächst mit der Mitarbeiterzahl",
        "right": "Effektiv flach"
      },
      {
        "label": "Integrationen",
        "left": "Nur was sie erlauben",
        "right": "Alles, was du brauchst"
      }
    ],
    "processKicker": "// how_we_build",
    "processTitle": "Von Abo-Chaos zu eigener Software",
    "steps": [
      {
        "title": "Deinen Workflow kartieren",
        "body": "Wir finden heraus, wie dein Unternehmen wirklich läuft und wo deine aktuellen Tools am meisten schmerzen."
      },
      {
        "title": "Den Plan entwerfen",
        "body": "Ein klarer Plan für Tool, Umfang und Kosten – kein Schnickschnack, keine Überraschungen."
      },
      {
        "title": "In Sprints entwickeln",
        "body": "Arbeitsfähige Software in Wochen, in Inkrementen geliefert, die du sehen und mitgestalten kannst."
      },
      {
        "title": "Besitzen und entwickeln",
        "body": "Du bekommst die Schlüssel. Wir verbessern es weiter oder übergeben komplett – deine Entscheidung."
      }
    ],
    "faqKicker": "// questions",
    "faqTitle": "Besitzen vs. Mieten — beantwortet",
    "faqs": [
      {
        "q": "Ist die Entwicklung von individueller Software nicht teurer als SaaS?",
        "a": "Anfangs manchmal. Über 2–3 Jahre gewinnt Custom-Software meistens – besonders wenn SaaS-Pro-Platz-Gebühren, Add-ons und Preiserhöhungen sich anhäufen. Und am Ende besitzt du einen Vermögenswert statt einem Stapel Belege."
      },
      {
        "q": "Was, wenn sich meine Anforderungen später ändern?",
        "a": "Genau darum geht es. Weil es dir gehört, entwickelt sich das Tool mit dir – neue Funktionen, neue Workflows, neue Integrationen – nach deinem Zeitplan, nicht dem eines Anbieters."
      },
      {
        "q": "Benötige ich ein technisches Team, um es zu betreiben?",
        "a": "Nein. Wir hosten, warten und betreuen es für dich, wenn du möchtest, oder übergeben die vollständige Dokumentation und den Zugriff, wenn du es lieber selbst betreiben willst."
      },
      {
        "q": "Kann es mehrere Tools gleichzeitig ersetzen?",
        "a": "Oft ja. Die Konsolidierung von 3–5 überlappenden Abonnements in ein perfekt passendes Tool ist eines der häufigsten – und profitabelsten – Projekte, die wir durchführen."
      },
      {
        "q": "Wie lange dauert es, bis ich etwas Reales sehe?",
        "a": "Normalerweise ein paar Wochen für eine erste funktionierende Version. Wir bauen in Inkrementen, sodass du nie monatelang auf Fortschritte warten musst."
      }
    ],
    "ctaTitle": "Hör auf zu mieten. Fang an zu besitzen.",
    "ctaBody": "Sag uns, welche SaaS-Abos dein Geschäft ausbremsen. Wir zeigen dir, wie es aussieht, das richtige Tool zu besitzen."
  },
  {
    "slug": "custom-crm",
    "eyebrow": "// your_crm",
    "title": "Ein CRM, das zu dir passt – [[nicht umgekehrt.]]",
    "subtitle": "Salesforce ist aufgebläht. HubSpot ist starr. Die „einfachen“ sind zu einfach. Wir entwickeln ein CRM rund um deinen tatsächlichen Vertriebsprozess – jede Pipeline, jedes Feld und jede Automatisierung genau so, wie dein Team verkauft.",
    "metaTitle": "Individuelle CRM-Entwicklung – Besser als Standard | DevCore",
    "metaDescription": "Generische CRMs zwingen dein Team zur Anpassung. DevCore entwickelt ein individuelles CRM, das genau auf deine Pipeline, Automatisierungen und Daten zugeschnitten ist – keine Aufblähung, keine Pro-Sitz-Gebühren, keine Kompromisse.",
    "stats": [
      {
        "value": "1",
        "label": "ungenutzte Funktionen, für die du zahlst"
      },
      {
        "value": "0",
        "label": "Deine Daten, deine Regeln"
      }
    ],
    "problemKicker": "// the_struggle",
    "problemTitle": "Dein CRM sollte dich beim Verkaufen unterstützen – nicht ausbremsen",
    "problemBody": "Die meisten Teams ertrinken entweder in einem CRM, das zu viel kann, oder wachsen aus einem heraus, das zu wenig kann. Also leben sie in Tabellen, verlieren Deals in den Ritzen und zahlen für Hunderte von Funktionen, die sie nie nutzen werden.",
    "problemPoints": [
      "Pipelines, die nicht zu deiner tatsächlichen Verkaufsweise passen",
      "Stunden, die durch manuelle Dateneingabe und Kopieren/Einfügen verloren gehen",
      "Preisgestaltung pro Sitzplatz, die das Wachstum des Teams schmerzhaft macht",
      "Berichte, die nie die Frage beantworten, die du stellst",
      "Die Hälfte deines Prozesses lebt noch in Tabellen"
    ],
    "pillarsKicker": "// what_you_get",
    "pillarsTitle": "Ein CRM, das darauf ausgelegt ist, wie dein Team wirklich verkauft",
    "pillars": [
      {
        "icon": "Workflow",
        "title": "Deine exakte Pipeline",
        "body": "Phasen, Felder und Regeln, die deinem tatsächlichen Vertriebsprozess entsprechen – nicht einer generischen Vorlage, die du mühsam anpassen musst."
      },
      {
        "icon": "Zap",
        "title": "Automatisierung, die passt",
        "body": "Follow-ups, Übergaben, Erinnerungen und Dateneingabe werden automatisch und genau dort erledigt, wo dein Prozess sie braucht."
      },
      {
        "icon": "Database",
        "title": "Eine einzige Quelle der Wahrheit",
        "body": "Kontakte, Deals, Angebote, E-Mails und Historie an einem Ort – verbunden mit deinen anderen Tools, nicht isoliert."
      },
      {
        "icon": "Gauge",
        "title": "Berichte, die Antworten liefern",
        "body": "Dashboards, die auf die Entscheidungen zugeschnitten sind, die du tatsächlich triffst, mit den Kennzahlen, die für dein Unternehmen zählen."
      }
    ],
    "compareKicker": "// side_by_side",
    "compareTitle": "Standard-CRM vs. dein individuelles CRM",
    "compareLeftLabel": "Generisches CRM",
    "compareRightLabel": "Dein individuelles CRM",
    "compareRows": [
      {
        "label": "Pipeline",
        "left": "Feste Vorlagen",
        "right": "An deinen Prozess angepasst"
      },
      {
        "label": "Funktionen",
        "left": "Zahlen für 100, nutzen 10",
        "right": "Genau das, was du brauchst"
      },
      {
        "label": "Preise",
        "left": "Pro Sitzplatz pro Monat",
        "right": "Du besitzt es, skalierst kostenlos"
      },
      {
        "label": "Automatisierung",
        "left": "Begrenzt / kostenpflichtig",
        "right": "Maßgeschneidert für dich"
      },
      {
        "label": "Daten",
        "left": "Deren Cloud, deren Regeln",
        "right": "Deine, vollständig portierbar"
      },
      {
        "label": "Integrationen",
        "left": "Marktplatz-Roulette",
        "right": "Was auch immer du nutzt"
      }
    ],
    "processKicker": "// how_we_build",
    "processTitle": "Vom Tabellen-Chaos zu einem CRM, das du liebst",
    "steps": [
      {
        "title": "Wir begleiten deinen Vertrieb",
        "body": "Wir erfassen, wie Leads tatsächlich vom ersten Kontakt bis zum abgeschlossenen Deal gelangen."
      },
      {
        "title": "Die Pipeline entwerfen",
        "body": "Ein Entwurf von Phasen, Feldern, Automatisierungen und Berichten – vereinbart, bevor wir mit dem Bau beginnen."
      },
      {
        "title": "Erstellen & migrieren",
        "body": "Wir liefern in Sprints und übertragen deine vorhandenen Daten sauber."
      },
      {
        "title": "Einführen & verfeinern",
        "body": "Dein Team nimmt es schnell an, weil es so funktioniert, wie ihr es ohnehin gewohnt seid."
      }
    ],
    "faqKicker": "// questions",
    "faqTitle": "Individuelles CRM – Fragen & Antworten",
    "faqs": [
      {
        "q": "Könnt ihr unsere Daten aus unserem aktuellen CRM oder aus Tabellen migrieren?",
        "a": "Ja. Eine saubere Migration von Salesforce, HubSpot, Pipedrive, Excel oder Google Sheets ist Teil des Projekts, so dass nichts zurückbleibt."
      },
      {
        "q": "Wird es sich in unsere E-Mails, Kalender und andere Tools integrieren?",
        "a": "Absolut. E-Mail, Kalender, Rechnungsstellung, Support, Marketing – wir verbinden das CRM mit den Tools, auf die du dich bereits verlässt."
      },
      {
        "q": "Lohnt sich ein individuelles CRM wirklich gegenüber HubSpot oder Salesforce?",
        "a": "Wenn dein Prozess nicht standardisiert ist oder die Gebühren pro Platz wehtun, ja. Du bekommst ein Tool, das genau passt, und ein Asset, das dir gehört, statt einem ständig wachsenden Abo."
      },
      {
        "q": "Wie lange dauert der Bau?",
        "a": "Eine fokussierte erste Version ist typischerweise innerhalb weniger Wochen live. Wir erweitern sie dann basierend darauf, wie dein Team sie täglich nutzt."
      },
      {
        "q": "Kann es mit uns wachsen?",
        "a": "Das ist der Vorteil, wenn es dir gehört. Neue Vertriebsabläufe, Teams, Regionen oder Produktlinien kommen bei Bedarf dazu – ganz ohne alles neu aufbauen zu müssen."
      }
    ],
    "ctaTitle": "Bau das CRM, das dein Team tatsächlich nutzen wird.",
    "ctaBody": "Erzähl uns, wie du verkaufst. Wir zeigen dir ein CRM, das auf deine Pipeline zugeschnitten ist – nicht auf die Vorlage von jemand anderem."
  },
  {
    "slug": "build-an-app-without-headaches",
    "eyebrow": "// no_headaches",
    "title": "Entwickle deine App [[ohne Kopfschmerzen.]]",
    "subtitle": "Vage Kostenvoranschläge, verpasste Fristen, Agenturen, die abtauchen, Code, den du nicht lesen kannst. Eine App zu entwickeln sollte sich nicht wie ein Glücksspiel anfühlen. Mit einem erfahrenen Team und einem klaren Plan ist es das auch nicht.",
    "metaTitle": "App erstellen ohne Kopfschmerzen — Von Profis | DevCore",
    "metaDescription": "Vergiss verpasste Fristen, unerwartete Rechnungen und unsauberen Code. DevCore entwickelt deine Web- oder Mobile-App mit erfahrenen Entwicklern, einem klaren Plan und Software, die wirklich dir gehört.",
    "stats": [
      {
        "value": "1",
        "label": "Senior-Team, End-to-End"
      },
      {
        "value": "0",
        "label": "Überraschungsrechnungen"
      },
      {
        "value": "100%",
        "label": "Sauberer, dokumentierter Code"
      }
    ],
    "problemKicker": "// the_headache",
    "problemTitle": "Warum die meisten App-Projekte scheitern",
    "problemBody": "Du kennst die Horrorgeschichten – oder hast sie selbst erlebt. Budgets, die sich verdoppeln, Zeitpläne, die sich verschieben, ein MVP, das unter der Haube ein Chaos ist. Das Problem ist meist nicht die Idee. Es ist das Fehlen eines klaren Plans und eines Teams, das wirklich Verantwortung für das Ergebnis übernimmt.",
    "problemPoints": [
      "Kostenvoranschläge, die sich mitten im Projekt verdoppeln",
      "Fristen, die ohne klaren Grund überschritten werden",
      "Code, der so unordentlich ist, dass der nächste Entwickler von vorne anfangen muss",
      "Agenturen, die sich zurückziehen, sobald es schwierig wird",
      "Eine App, die technisch funktioniert, aber niemand gerne benutzt"
    ],
    "pillarsKicker": "// how_it_should_be",
    "pillarsTitle": "Wie sich das Entwickeln mit Profis anfühlt",
    "pillars": [
      {
        "icon": "FileText",
        "title": "Zuerst ein klarer Plan",
        "body": "Bevor eine Zeile Code geschrieben wird, bekommst du einen Plan: Umfang, Zeitplan und ein festes, ehrliches Budget. Keine Rätsel, keine „Scope-Creep“-Überraschungen."
      },
      {
        "icon": "Code2",
        "title": "Nur erfahrene Ingenieure",
        "body": "Dein Projekt wird nicht an Junioren weitergereicht. Erfahrene Entwickler treffen früh die richtigen Entscheidungen – die, die dir später Monate ersparen."
      },
      {
        "icon": "Eye",
        "title": "Volle Transparenz",
        "body": "Du verfolgst den Fortschritt wöchentlich an funktionierender Software, nicht an Statusberichten. Du weißt immer, wo die Dinge stehen."
      },
      {
        "icon": "Rocket",
        "title": "Durchdacht und dein Eigentum",
        "body": "Schnell, schön, zuverlässig – und vollständig dein Eigentum, mit sauberem Code und Dokumentation, damit du nie von jemandem abhängig bist."
      }
    ],
    "compareKicker": "// side_by_side",
    "compareTitle": "Typische Agentur vs. Entwicklung mit DevCore",
    "compareLeftLabel": "Typische Erfahrung",
    "compareRightLabel": "Mit DevCore",
    "compareRows": [
      {
        "label": "Preisgestaltung",
        "left": "Vage, dann wächst es",
        "right": "Klar & fest von Anfang an"
      },
      {
        "label": "Team",
        "left": "Ausgelagerte Junioren",
        "right": "Erfahrene Ingenieure"
      },
      {
        "label": "Fortschritt",
        "left": "Statusberichte",
        "right": "Wöchentlich funktionierende Software"
      },
      {
        "label": "Code",
        "left": "Unordentlich, undokumentiert",
        "right": "Sauber, dokumentiert"
      },
      {
        "label": "Design",
        "left": "Am Ende angeflanscht",
        "right": "Von Anfang an integriert"
      },
      {
        "label": "Nach der Einführung",
        "left": "Tauchen ab",
        "right": "Wir bleiben dabei"
      }
    ],
    "processKicker": "// how_we_build",
    "processTitle": "Ein ruhiger, berechenbarer Weg zur Einführung",
    "steps": [
      {
        "title": "Entdeckung",
        "body": "Wir klären schnell, was entwickelt werden soll, für wen und warum es wichtig ist."
      },
      {
        "title": "Blaupause",
        "body": "Umfang, Designrichtung, Zeitplan und ein festes Budget, das du abnimmst."
      },
      {
        "title": "Entwicklung in Sprints",
        "body": "Wöchentlich funktionierende Funktionen, wobei dein Feedback jede einzelne steuert."
      },
      {
        "title": "Einführung & Support",
        "body": "Wir liefern aus, beobachten den Start und verbessern es mit dir weiter."
      }
    ],
    "faqKicker": "// questions",
    "faqTitle": "App-Entwicklung – Fragen beantwortet",
    "faqs": [
      {
        "q": "Ich habe eine Idee, aber keinen technischen Hintergrund. Könnt ihr trotzdem helfen?",
        "a": "Ja – die meisten unserer Kunden sind nicht technisch. Wir übersetzen deine Idee in einen klaren Plan und kümmern uns um jede technische Entscheidung, alles in verständlicher Sprache."
      },
      {
        "q": "Web-App, mobile App oder beides?",
        "a": "Alles davon. Wir entwickeln Web-Apps, mobile Apps und die dazugehörige Technik im Hintergrund – und beraten dich, was für deine Ziele und dein Budget sinnvoll ist."
      },
      {
        "q": "Wie verhindert ihr, dass das Budget explodiert?",
        "a": "Wir spezifizieren und bepreisen den Projektplan, bevor die Entwicklung beginnt. Du gibst ihn frei, und wir entwickeln schrittweise – so gibt es keine Überraschungen mitten im Projekt."
      },
      {
        "q": "Werde ich den Code besitzen?",
        "a": "Vollständig. Du bekommst sauberen, dokumentierten Code und vollen Zugriff. Keine Bindung, niemand nimmt dein Projekt in Geiselhaft."
      },
      {
        "q": "Was passiert nach der Einführung?",
        "a": "Wir tauchen nicht ab. Wir überwachen, betreuen und verbessern die App, während dein Unternehmen wächst – so lange du uns dabei haben willst."
      }
    ],
    "ctaTitle": "Lass es uns richtig bauen – gleich beim ersten Mal.",
    "ctaBody": "Erzähl uns von deiner App-Idee. Wir verwandeln sie in einen klaren Plan mit echtem Zeitplan und Budget."
  },
  {
    "slug": "custom-portal-not-a-builder",
    "eyebrow": "// your_portal",
    "title": "Kundenportal entwickeln lassen – [[nicht aus einer Vorlage.]]",
    "subtitle": "Website-Builder und Portal-Vorlagen zwängen dein Unternehmen in ihre Schranken. Wir entwickeln Kundenportale, Partnerportale und interne Portale exakt nach deiner Vision – jeder Flow, jede Berechtigung und jeder Pixel.",
    "metaTitle": "Kundenportal Software individuell entwickeln lassen | DevCore",
    "metaDescription": "Kundenportal-Software statt Baukasten: DevCore entwickelt Kunden-, Partner- und interne Portale exakt nach deinen Vorgaben – deine Abläufe, dein Branding, deine Rollen und Rechte.",
    "stats": [
      {
        "value": "0",
        "label": "Vorlagen-Einschränkungen"
      },
      {
        "value": "100%",
        "label": "Deine Marke & Abläufe"
      },
      {
        "value": "∞",
        "label": "Wachstumsmöglichkeiten"
      }
    ],
    "problemKicker": "// the_box",
    "problemTitle": "Builder geben dir eine Box. Dein Unternehmen passt nicht hinein.",
    "problemBody": "Drag-and-Drop-Builder und Portalvorlagen wirken schnell – bis du an Grenzen stößt. Der Anmelde-Flow, den du brauchst, ist nicht möglich. Die Berechtigungen passen nicht zu deiner Organisation. Das Branding reicht nur bis zu einem gewissen Punkt. Am Ende zahlst du monatlich für etwas, das immer noch nicht passt.",
    "problemPoints": [
      "Starre Vorlagen, die deinen tatsächlichen Workflows widersprechen",
      "Berechtigungsmodelle, die nicht zur Arbeitsweise deiner Teams passen",
      "Branding, das bei einem Logo und einer Farbe endet",
      "Integrationen blockiert, es sei denn, du upgradest – schon wieder",
      "Monatliche Gebühren für ein Portal, das immer noch 'fast' richtig ist"
    ],
    "pillarsKicker": "// what_you_get",
    "pillarsTitle": "Ein Portal, das vollständig auf dich zugeschnitten ist",
    "pillars": [
      {
        "icon": "Layout",
        "title": "Exakt deine Vision",
        "body": "Jeder Bildschirm, jeder Flow und jede Interaktion wird nach deinen Vorgaben gebaut – nicht aus den Blöcken zusammengesetzt, die ein Builder zufällig anbietet."
      },
      {
        "icon": "ShieldCheck",
        "title": "Passende Rollen & Berechtigungen",
        "body": "Granularer Zugriff für Kunden, Partner, Teams und Administratoren – modelliert nach deiner realen Organisation, nicht nach einer generischen Voreinstellung."
      },
      {
        "icon": "Boxes",
        "title": "Mit allem verbunden",
        "body": "Dein CRM, deine Abrechnung, dein Support, dein Data Warehouse – das Portal integriert sich in die Systeme, die du bereits nutzt, ohne künstliche Grenzen."
      },
      {
        "icon": "Sparkles",
        "title": "Pixelgenau gebrandet",
        "body": "Es sieht unverkennbar nach dir aus und fühlt sich auch so an – ein Premium-Produkterlebnis, keine wiedererkennbare Vorlage."
      }
    ],
    "compareKicker": "// side_by_side",
    "compareTitle": "Website-Builder vs. ein individuelles Portal",
    "compareLeftLabel": "Builder / Vorlage",
    "compareRightLabel": "Dein individuelles Portal",
    "compareRows": [
      {
        "label": "Flows",
        "left": "Was immer in die Blöcke passt",
        "right": "Exakt deine Spezifikation"
      },
      {
        "label": "Berechtigungen",
        "left": "Grundlegende Voreinstellungen",
        "right": "Modelliert nach deiner Organisation"
      },
      {
        "label": "Branding",
        "left": "Logo + Farben",
        "right": "Pixelgenau, deins"
      },
      {
        "label": "Integrationen",
        "left": "Begrenzt, hinter Bezahlschranke",
        "right": "Alles, was du nutzt"
      },
      {
        "label": "Preise",
        "left": "Monatlich, für immer",
        "right": "Du besitzt es direkt"
      },
      {
        "label": "Wachstum",
        "left": "Du stößt an Grenzen",
        "right": "Keine Grenzen"
      }
    ],
    "processKicker": "// how_we_build",
    "processTitle": "Von 'fast richtig' zu genau richtig",
    "steps": [
      {
        "title": "Die Vision definieren",
        "body": "Wir erfassen deine Nutzer, Abläufe und das gewünschte Nutzererlebnis."
      },
      {
        "title": "Den Bauplan entwerfen",
        "body": "Bildschirme, Rollen, Integrationen und Umfang – vereinbart, bevor wir bauen."
      },
      {
        "title": "In Sprints bauen",
        "body": "Ein funktionierendes Portal in Wochen, mit deinem Feedback in jedem Schritt verfeinert."
      },
      {
        "title": "Starten & weiterentwickeln",
        "body": "Live gehen und dann wachsen lassen – neue Module und Abläufe, wann immer du sie brauchst."
      }
    ],
    "faqKicker": "// questions",
    "faqTitle": "Individuelle Portale – Fragen und Antworten",
    "faqs": [
      {
        "q": "Welche Art von Portalen baut ihr?",
        "a": "Kundenportale, Partner- und Reseller-Portale, Kunden-Dashboards, interne Team-Portale, Mitgliederbereiche – alles, wo sich Menschen anmelden, um etwas zu erledigen."
      },
      {
        "q": "Kann es mit unseren bestehenden Systemen verbunden werden?",
        "a": "Ja. Wir verbinden dein CRM, deine Abrechnung, deinen Support, dein Login-System und deine Datenquellen, sodass das Portal sauber mit deinen bestehenden Programmen zusammenarbeitet statt als Insellösung dazustehen."
      },
      {
        "q": "Wie unterscheidet sich das von einem Website-Builder?",
        "a": "Ein Builder schränkt dich auf seine Blöcke und Regeln ein. Wir bauen nach deinen exakten Anforderungen – individuelle Abläufe, echte Berechtigungsmodelle und unbegrenzte Integrationen – und dir gehört das Ergebnis."
      },
      {
        "q": "Können wir später weitere Funktionen hinzufügen?",
        "a": "Immer. Da es individuell ist und dir gehört, lassen sich neue Module, Benutzertypen und Workflows jederzeit ergänzen, wenn dein Unternehmen sie braucht."
      },
      {
        "q": "Wie sicher ist es?",
        "a": "Sicherheit ist von Anfang an eingebaut – sicherer Login, klar geregelte Zugriffsrechte je nach Rolle und Datenschutz, statt nachträglich auf eine Vorlage gepfuscht."
      }
    ],
    "ctaTitle": "Bau das Portal, das du dir tatsächlich vorgestellt hast.",
    "ctaBody": "Beschreib das Portal in deinem Kopf. Wir verwandeln es in einen Bauplan und bauen es genau so."
  },
  {
    "slug": "tools-that-dont-exist-yet",
    "eyebrow": "// build_the_unbuilt",
    "title": "Bau das Tool, [[das es noch nicht gibt.]]",
    "subtitle": "Manchmal gibt es das perfekte Tool einfach nicht auf dem Markt – oder die vorhandenen können viel zu viel oder viel zu wenig. Wir entwickeln genau das Tool, das dein Unternehmen braucht, nicht mehr und nicht weniger.",
    "metaTitle": "Maßgeschneiderte Tools entwickeln, die es noch nicht gibt | DevCore",
    "metaDescription": "Du findest nicht das richtige Tool – oder sitzt mit überladener Software fest, die du kaum nutzt? DevCore entwickelt genau das maßgeschneiderte Tool, das dein Unternehmen braucht, passgenau und in deinem Besitz.",
    "stats": [
      {
        "value": "1",
        "label": "passgenaues Tool"
      },
      {
        "value": "0",
        "label": "überflüssiger Ballast"
      },
      {
        "value": "100%",
        "label": "für deinen Workflow gemacht"
      }
    ],
    "problemKicker": "// the_gap",
    "problemTitle": "Das richtige Tool existiert entweder nicht – oder kann zu viel",
    "problemBody": "Du hast gesucht. Entweder löst kein Produkt am Markt dein spezifisches Problem, oder alles kommt mit Overhead, Funktionen und Preisen, die du nie brauchen wirst. Also gibst du dich damit zufrieden, und dein Team zahlt jeden Tag dafür – in verlorener Zeit.",
    "problemPoints": [
      "Kein Produkt am Markt kann das Eine, was du wirklich brauchst",
      "Die nächsten Optionen sind überladen und überteuert",
      "Manuelle, repetitive Arbeit, für die niemand Zeit hat",
      "Ein Flickenteppich aus Tabellen und halb funktionierenden Hacks",
      "Jede Woche gehen Stunden verloren wegen eines Problems, das Software lösen sollte"
    ],
    "pillarsKicker": "// what_you_get",
    "pillarsTitle": "Das exakte Tool – nichts mehr, nichts weniger",
    "pillars": [
      {
        "icon": "Target",
        "title": "Maßgeschneidert",
        "body": "Entwickelt, um genau dein Problem zu lösen, und zwar so, wie dein Team tatsächlich arbeitet – nicht als Durchschnitt der Bedürfnisse anderer."
      },
      {
        "icon": "Feather",
        "title": "Kein Ballast",
        "body": "Keine Funktionen, die du nie nutzt, kein Overhead, den du zahlst, aber ignorierst. Schlank, fokussiert und schnell."
      },
      {
        "icon": "Zap",
        "title": "Automatisiert Routineaufgaben",
        "body": "Die repetitive, manuelle Arbeit, die deine Woche auffrisst – erledigt. Dein Team gewinnt die Stunden zurück."
      },
      {
        "icon": "Layers",
        "title": "Wächst nach Bedarf",
        "body": "Starte mit dem Kern-Tool und ergänze genau die Funktionen, die du brauchst, wann du sie brauchst."
      }
    ],
    "compareKicker": "// side_by_side",
    "compareTitle": "Ein Markt-Tool erzwingen vs. dein eigenes bauen",
    "compareLeftLabel": "Nächstes Markt-Tool",
    "compareRightLabel": "Dein maßgeschneidertes Tool",
    "compareRows": [
      {
        "label": "Passform",
        "left": "Ziemlich nah, nie exakt",
        "right": "Passgenau für die Aufgabe"
      },
      {
        "label": "Funktionen",
        "left": "Überladen oder fehlend",
        "right": "Genau richtig"
      },
      {
        "label": "Overhead",
        "left": "Zahlen für Unbenutztes",
        "right": "Keiner"
      },
      {
        "label": "Workflow",
        "left": "Du passt dich an",
        "right": "Es passt sich dir an"
      },
      {
        "label": "Kosten",
        "left": "Abonnement für immer",
        "right": "Du besitzt es"
      },
      {
        "label": "Zukunft",
        "left": "Warten auf deren Roadmap",
        "right": "Ergänze, was du brauchst"
      }
    ],
    "processKicker": "// how_we_build",
    "processTitle": "Von 'das sollte es geben' bis 'es existiert'",
    "steps": [
      {
        "title": "Problem definieren",
        "body": "Wir legen glasklar fest, was das Tool brilliant leisten muss."
      },
      {
        "title": "Konzept erstellen",
        "body": "Umfang, Design und ein festes Budget für ein schlankes, fokussiertes Tool."
      },
      {
        "title": "Kern entwickeln",
        "body": "Eine funktionierende Version in Wochen – das essentielle Tool, das seine Aufgabe erfüllt."
      },
      {
        "title": "Verfeinern & erweitern",
        "body": "Im realen Einsatz verfeinern und dann Funktionen nur bei Bedarf hinzufügen."
      }
    ],
    "faqKicker": "// questions",
    "faqTitle": "Das Ungebaute bauen – Fragen & Antworten",
    "faqs": [
      {
        "q": "Was, wenn ich mir nicht sicher bin, wie das Tool genau aussehen soll?",
        "a": "Das ist normal – und genau dabei helfen wir am meisten. Wir starten beim Problem und formen mit dir das richtige Tool, sodass du keine fertige Spezifikation brauchst, um loszulegen."
      },
      {
        "q": "Lohnt es sich, etwas so Spezifisches zu bauen?",
        "a": "Wenn dich das Problem jede Woche echte Zeit oder echtes Geld kostet, fast immer. Ein fokussiertes Tool, das perfekt passt, amortisiert sich viel schneller, als man denkt."
      },
      {
        "q": "Kann es KI nutzen?",
        "a": "Ja. Wenn es wirklich hilft – Entscheidungen automatisiert, Text oder Daten verarbeitet, dein Team unterstützt – bauen wir KI mit sinnvollen Schutzvorkehrungen ein. Wenn nicht, halten wir es einfach."
      },
      {
        "q": "Wie klein kann ein Projekt sein?",
        "a": "Klein ist in Ordnung. Ein einziges scharfes Tool, das einen schmerzhaften Engpass beseitigt, gehört zu den ROI-stärksten Dingen, die wir bauen."
      },
      {
        "q": "Werde ich es besitzen?",
        "a": "Ja – vollständig. Sauberer Code, voller Zugriff, keine Bindung. Es ist dein Tool und dein Asset."
      }
    ],
    "ctaTitle": "Wenn es das geben sollte, lass es uns bauen.",
    "ctaBody": "Beschreib das Tool, das du dir wünschst. Wir sagen dir genau, wie wir es bauen würden – und dir gehört es."
  },
  {
    "slug": "combine-your-tools-into-one-suite",
    "eyebrow": "// one_suite",
    "title": "Viele einzelne Tools. [[Eine maßgeschneiderte Suite.]]",
    "subtitle": "Dein Team springt zwischen einem Dutzend Apps hin und her, kopiert Daten von Hand und zahlt für jede einzeln. Wir vereinen die kleinen Tools, die du tatsächlich nutzt, in einer einzigen, maßgeschneiderten Suite – ein Login, eine zentrale Datenquelle, nahtlos in deinen Arbeitsablauf integriert.",
    "metaTitle": "Mehrere Tools zu einer Custom Suite bündeln | DevCore",
    "metaDescription": "Hör auf, mit einem Dutzend unverbundener Apps zu jonglieren. DevCore vereint deine kleinen Tools in einer maßgeschneiderten Suite – ein Login, geteilte Daten, kein Kopieren und kein Abo-Stapel mehr.",
    "stats": [
      {
        "value": "1",
        "label": "Suite statt Dutzende Apps"
      },
      {
        "value": "0",
        "label": "Kopieren und Einfügen zwischen Tools"
      },
      {
        "value": "100%",
        "label": "verbundene, geteilte Daten"
      }
    ],
    "problemKicker": "// the_sprawl",
    "problemTitle": "Ein Dutzend Apps, die nicht miteinander kommunizieren",
    "problemBody": "Jedes Problem bekam sein eigenes Tool, und jetzt lebt dein Team im Tab-Chaos. Daten liegen in mehreren Apps doppelt, nichts bleibt synchron, und du zahlst für jede ein eigenes Abo. Die Tools sollten Zeit sparen – zusammen verschwenden sie sie still und leise.",
    "problemPoints": [
      "Dieselben Daten werden in drei oder vier verschiedene Apps erneut eingegeben",
      "Endloses Tab-Wechseln und unterbrochener Kontext den ganzen Tag lang",
      "Tools, die sich nicht synchronisieren, sodass Zahlen nie ganz übereinstimmen",
      "Ein Stapel separater Abonnements, der sich jeden Monat summiert",
      "Kein einziger Ort, um zu sehen, was tatsächlich vor sich geht"
    ],
    "pillarsKicker": "// what_you_get",
    "pillarsTitle": "Alles, was dein Team braucht, an einem Ort",
    "pillars": [
      {
        "icon": "Boxes",
        "title": "Deine Tools, vereint",
        "body": "Die wenigen kleinen Apps, auf die du dich verlässt, neu aufgebaut als vernetzte Module in einer Suite – so konzipiert, dass sie zusammenarbeiten, statt sich gegenseitig zu behindern."
      },
      {
        "icon": "Database",
        "title": "Eine zentrale Datenquelle",
        "body": "Daten einmal eingeben und sie sind dort, wo sie sein sollen. Keine Duplikate, keine Exporte, kein Kopieren und Einfügen – jedes Modul teilt dieselben Live-Daten."
      },
      {
        "icon": "Layers",
        "title": "Ein Login, ein Erlebnis",
        "body": "Eine einzige, konsistente Oberfläche und ein Satz von Berechtigungen für alles – dein Team lernt es einmal und muss nicht mehr in Apps suchen."
      },
      {
        "icon": "Zap",
        "title": "Weniger Kosten, weniger Overhead",
        "body": "Ersetze einen Stapel Abos und die Kopplungsarbeit dazwischen durch ein Tool, das dir gehört – niedrigere Betriebskosten und deutlich weniger Wartungsaufwand."
      }
    ],
    "compareKicker": "// side_by_side",
    "compareTitle": "Ein Flickenteppich von Apps vs. eine maßgeschneiderte Suite",
    "compareLeftLabel": "Verstreute Tools",
    "compareRightLabel": "Deine individuelle Suite",
    "compareRows": [
      {
        "label": "Daten",
        "left": "Überall dupliziert",
        "right": "Eine gemeinsame Quelle"
      },
      {
        "label": "Workflow",
        "left": "Ständiges Tab-Wechseln",
        "right": "Ein verbundener Workflow"
      },
      {
        "label": "Logins",
        "left": "Einer pro App",
        "right": "Single Sign-on"
      },
      {
        "label": "Kosten",
        "left": "Viele Abonnements",
        "right": "Eine eigene Suite"
      },
      {
        "label": "Integrationen",
        "left": "Brüchig, bricht oft",
        "right": "Eingebaut, nativ"
      },
      {
        "label": "Überblick",
        "left": "Verstreut, teilweise",
        "right": "Eine klare Ansicht"
      }
    ],
    "processKicker": "// how_we_build",
    "processTitle": "Vom Tool-Wildwuchs zur maßgeschneiderten Suite",
    "steps": [
      {
        "title": "Deine Tools unter die Lupe nehmen",
        "body": "Wir erfassen jedes Tool, das dein Team nutzt, und wie Daten tatsächlich dazwischen fließen."
      },
      {
        "title": "Die Suite entwerfen",
        "body": "Ein Bauplan der vereinheitlichten Module, des gemeinsamen Datenmodells und einer sauberen Oberfläche – vereinbart, bevor wir mit dem Bau beginnen."
      },
      {
        "title": "Bauen & Migrieren",
        "body": "Wir liefern die Suite in Sprints aus und migrieren deine Daten sauber von den alten Tools."
      },
      {
        "title": "Umstellung & Erweiterung",
        "body": "Dein Team wechselt zu einem Tool, und wir ergänzen Module, wenn neue Anforderungen entstehen."
      }
    ],
    "faqKicker": "// questions",
    "faqTitle": "Eine Suite – beantwortet",
    "faqs": [
      {
        "q": "Könnt ihr wirklich all unsere separaten Tools ersetzen?",
        "a": "Meistens die wichtigen, ja. Wir konzentrieren uns auf die Tools, die dein Team täglich nutzt, und die Daten, die dazwischen fließen, und bauen sie als vernetzte Module in einer Suite neu auf. Was besser einem Spezialtool überlassen bleibt, integrieren wir stattdessen."
      },
      {
        "q": "Was ist mit den Tools, die wir behalten möchten?",
        "a": "Kein Problem. Die Suite verbindet sich mit externen Tools, die du behalten möchtest – E-Mail, Buchhaltung, Zahlungen und so weiter – sodass alles an einem Ort zusammenläuft."
      },
      {
        "q": "Könnt ihr unsere vorhandenen Daten migrieren?",
        "a": "Ja. Die saubere Migration aus deinen aktuellen Apps und Tabellen ist Teil des Projekts, sodass beim Wechsel nichts zurückbleibt."
      },
      {
        "q": "Ist ein großes Tool nicht riskant im Vergleich zu vielen kleinen?",
        "a": "Es ist das Gegenteil eines fragilen Flickenteppichs. Eine gut gebaute, eigene Suite bedeutet weniger fehleranfällige Integrationen, weniger Anbieter und einen Ort für Sicherheit und Wartung – weitaus robuster als ein Dutzend Apps, die mit Klebeband zusammengehalten werden."
      },
      {
        "q": "Kann sie mit neuen Anforderungen wachsen?",
        "a": "Immer. Neue Module und Workflows kommen zur selben Suite dazu, wenn du sie brauchst – keine neuen Abos, kein neuer Integrations-Stress."
      }
    ],
    "ctaTitle": "Verwandle deinen Tool-Wildwuchs in eine Suite.",
    "ctaBody": "Sag uns, welche Apps dein Team täglich jongliert. Wir zeigen dir, wie sie sich in eine maßgeschneiderte Suite integrieren lassen."
  },
  {
    "slug": "why-not-vibecode-it-yourself",
    "eyebrow": "// vibecoding",
    "title": "Warum nicht einfach [[selbst vibecoden?]]",
    "subtitle": "KI lässt das Entwickeln mühelos erscheinen — bis aus der Demo ein echtes Produkt werden soll. Vibecoding ist genial für schnelle erste Versionen und gefährlich für den echten Betrieb. Hier zeigen wir, wo es bricht und warum ein erfahrenes Team deine Idee in Software verwandelt, der du wirklich vertrauen kannst.",
    "metaTitle": "Warum nicht einfach selbst vibecoden? Die ehrliche Antwort | DevCore",
    "metaDescription": "KI-Coding-Tools bauen einen Prototyp an einem Nachmittag — doch Produktivbetrieb ist eine andere Liga. Wo Vibecoding bricht (Sicherheit, Skalierung, Wartung) und wann Profis ranmüssen.",
    "stats": [
      { "value": "1 Tag", "label": "bis zum Demo — Monate bis zum echten Produkt" },
      { "value": "80%", "label": "der Arbeit sind die unsichtbaren 80%" },
      { "value": "100%", "label": "der Haftung bleiben bei dir" }
    ],
    "problemKicker": "// die_falle",
    "problemTitle": "Die Demo funktioniert. Genau das ist die Falle.",
    "problemBody": "Vibecoding liefert erstaunlich schnell ein funktionierendes Bild — und dieser erste Erfolg verbirgt alles darunter. Sicherer Login, verlässliche Daten, Sonderfälle, Sicherheit, Geschwindigkeit, Zahlungen, rechtliche Vorgaben: Nichts davon zeigt sich in der schönen Demo, und alles davon zeigt sich, sobald echte Nutzer (und Angreifer) kommen. Die Lücke zwischen „es läuft\" und „darauf würde ich mein Geschäft setzen\" ist genau dort, wo die meisten selbstgebauten Apps still zerbrechen.",
    "problemPoints": [
      "Sicherheitslücken, die du nicht siehst — offene Daten, fehlende Zugriffsregeln, geleakte Keys",
      "Code, der einmal funktioniert, den aber niemand — auch du nicht — später sicher ändern kann",
      "Sonderfälle, Fehler und seltsame Eingaben, die den echten Betrieb zum Absturz bringen",
      "Keine Tests, keine Backups, keine Überwachung — bis im echten Betrieb etwas bricht",
      "Jede Stunde Debugging von KI-Output ist eine Stunde, in der du dein Geschäft nicht führst"
    ],
    "pillarsKicker": "// die_realität",
    "pillarsTitle": "Was Vibecoding nicht auf den Bildschirm bringt",
    "pillars": [
      { "icon": "ShieldCheck", "title": "Sicherheit & verlässliche Daten", "body": "Sicherer Login, klare Zugriffsrechte, geprüfte Eingaben und sauber geschützte Passwörter & Schlüssel — die Dinge, die KI gern überspringt und Angreifer gern finden. Wir bauen sie von Anfang an ein." },
      { "icon": "TrendingUp", "title": "Auf Wachstum gebaut", "body": "Eine schnelle Version für 5 Nutzer kann bei 500 zusammenbrechen. Wir gestalten Daten, Abfragen und Technik im Hintergrund so, dass Wachstum kein Drama ist — und kein Neuaufbau." },
      { "icon": "Code2", "title": "Wartbare Grundlagen", "body": "Sauberer, dokumentierter, getesteter Code, den ein Mensch nachvollziehen kann — damit die App sich weiterentwickelt statt zur Blackbox zu werden, die du dich nicht anzufassen traust." },
      { "icon": "Eye", "title": "Urteilsvermögen, nicht nur Output", "body": "KI generiert Code; sie übernimmt nicht das Ergebnis. Erfahrene Entwickler treffen die Entscheidungen, die KI nicht kann — Abwägungen, sinnvoller Aufbau und das, was dir später Monate spart." }
    ],
    "compareKicker": "// im_vergleich",
    "compareTitle": "Selbst vibecoden vs. mit Profis bauen",
    "compareLeftLabel": "DIY-Vibecoding",
    "compareRightLabel": "Mit DevCore gebaut",
    "compareRows": [
      { "label": "Zeit bis Demo", "left": "Stunden", "right": "Stunden", "leftPositive": true },
      { "label": "Veröffentlichung", "left": "Manuell, fragil, bricht beim Aktualisieren", "right": "Automatisiert, mit sicherem Zurückrollen" },
      { "label": "Hosting & Technik", "left": "Ratespiel, keine Überwachung", "right": "Sauber eingerichtet, wächst mit, überwacht" },
      { "label": "Geschwindigkeit", "left": "Wird mit echten Daten langsam", "right": "Gemessen, beschleunigt, optimiert" },
      { "label": "Fehler & Sonderfälle", "left": "Tauchen erst im Live-Betrieb auf", "right": "Vor dem Start durch Tests abgefangen" },
      { "label": "Sicherheit", "left": "Unbekannt / Hoffnung", "right": "Eingebaut, geprüft, gehärtet" },
      { "label": "Verbindungen zu anderen Programmen", "left": "Brüchig zusammengeschustert", "right": "Robust und sauber dokumentiert" }
    ],
    "processKicker": "// so_bauen_wir",
    "processTitle": "Tempo behalten. Risiko verlieren.",
    "steps": [
      { "title": "Bring deinen Prototyp mit", "body": "Schon etwas vibegecodet? Perfekt — das ist die ideale Spezifikation. Wir machen daraus einen echten Plan." },
      { "title": "Das Echte als Blueprint", "body": "Umfang, Architektur, Sicherheit und ein fixes Budget — was der Produktivbetrieb wirklich braucht, ohne Rätselraten." },
      { "title": "Richtig bauen", "body": "Senior-Engineers liefern funktionierende Software in Sprints — mit Tests, Reviews und den unsichtbaren 80% erledigt." },
      { "title": "Launch & Eigentum", "body": "Du bekommst sauberen Code, volles Eigentum und ein Tool, dem du mit echten Nutzern und echtem Geld vertrauen kannst." }
    ],
    "faqKicker": "// fragen",
    "faqTitle": "Vibecoding vs. richtig bauen — beantwortet",
    "faqs": [
      { "q": "Ist KI nicht inzwischen gut genug, um meine ganze App zu bauen?", "a": "Für Prototypen und interne Experimente oft ja — und sie ist wirklich mächtig. Für Produktivsoftware mit echten Nutzern, Zahlungen, Daten und Sicherheit ist KI ein Werkzeug, kein Team. Sie schreibt schnell Code, übernimmt aber nicht Architektur, Abwägungen oder Konsequenzen. Genau da kommen wir ins Spiel." },
      { "q": "Ich habe schon etwas vibegecodet. Ist das verschwendet?", "a": "Überhaupt nicht — es ist ein Asset. Ein funktionierender Prototyp ist das klarste Briefing: Er zeigt genau, was du willst. Wir nutzen ihn als Blueprint und bauen ihn auf solider, sicherer, skalierbarer Basis neu — oft viel schneller, weil das Denken schon erledigt ist." },
      { "q": "Warum euch bezahlen, wenn KI so günstig ist?", "a": "Du zahlst nicht fürs Tippen von Code — das hat KI günstig gemacht. Du zahlst für Urteilsvermögen: die Sicherheit, die du nicht siehst, die Architektur, die nicht zusammenbricht, die Entscheidungen, die teure Neuaufbauten verhindern. Der günstige Teil war nie der Engpass." },
      { "q": "Nutzt ihr selbst auch KI?", "a": "Selbstverständlich — wir wären ohne sie langsamer. Der Unterschied: Wir nutzen sie unter Senior-Aufsicht, mit Reviews, Tests und Standards. Du bekommst das Tempo der KI mit der Verantwortung von Profis, nicht rohen Output im Produktivbetrieb." },
      { "q": "Woran erkenne ich, wann ich vom DIY zu euch wechseln sollte?", "a": "Sobald echte Nutzer, echtes Geld oder sensible Daten im Spiel sind — oder wenn du mehr Zeit damit verbringst, deinen Code zu bekämpfen, als dein Geschäft aufzubauen. Wenn ein Bug Kunden kosten oder ein Leak Vertrauen kosten kann, ist es Zeit." }
    ],
    "ctaTitle": "Tempo lieben? Behalt es — ohne das Risiko.",
    "ctaBody": "Schick uns deinen vibegecodeten Prototyp oder einfach die Idee. Wir zeigen dir, was nötig ist, um ihn produktionsreif zu machen — und bauen ihn für dich."
  },
  {
    "slug": "ai-built-into-your-software",
    "eyebrow": "// ai_inside",
    "title": "KI, die echte Arbeit übernimmt — [[fest in deine Software gebaut.]]",
    "subtitle": "Die meisten kleben einen Chatbot an ein fertiges Produkt und nennen das KI. Wir bauen Intelligenz in den Kern dessen, was wir entwickeln — sie liest Dokumente, beantwortet Nutzerfragen, erkennt Trends und sortiert das Chaos, jeden Tag.",
    "metaTitle": "KI fest in deine Software gebaut — nicht aufgeklebt | DevCore",
    "metaDescription": "Schluss mit Chatbots, die an ein fertiges Produkt geklebt werden. DevCore baut KI in den Kern deiner Software: PDF-Analyse, Copilots, KPI-Analysen, Scraping und intelligente Organisation.",
    "stats": [
      { "value": "9", "label": "KI-Fähigkeiten, produktiv eingesetzt" },
      { "value": "24/7", "label": "Arbeit automatisch erledigt" },
      { "value": "0", "label": "manuelles Copy-Paste übrig" }
    ],
    "problemKicker": "// die_spielerei",
    "problemTitle": "Ein Chatbot in der Ecke ist keine KI-Strategie",
    "problemBody": "Einen generischen Assistenten an eine fertige App zu kleben sieht modern aus, ändert aber nichts. Dein Team tippt weiter Daten aus PDFs ab, sucht nach Antworten, baut Reports von Hand und ertrinkt in unsortierten Elementen. Echte KI nimmt die Arbeit ab — sie wartet nicht nur darauf, gefragt zu werden.",
    "problemPoints": [
      "Stunden verloren beim Abtippen von Daten aus PDFs, Rechnungen und Verträgen",
      "Nutzer wühlen sich durch Dokumente, statt Antworten zu bekommen",
      "Reports von Hand gebaut, immer eine Woche veraltet",
      "Daten verstreut über Webseiten, andere Programme und Tabellen",
      "Postfächer und Queues stapeln sich, nichts wird automatisch sortiert"
    ],
    "pillarsKicker": "// was_wir_bauen",
    "pillarsTitle": "Neun Wege, wie KI echte Arbeit in deinem Produkt leistet",
    "pillars": [
      {
        "icon": "FileText",
        "title": "Dokumenten- & PDF-Analyse",
        "body": "Verträge, Rechnungen oder Reports rein, sauber strukturierte Daten raus — ohne manuelles Tippen, ohne Copy-Paste, ohne Fehler."
      },
      {
        "icon": "Sparkles",
        "title": "Integrierter Copilot & Chatbot",
        "body": "Ein kontextbewusster Assistent direkt in deinem Produkt, der Fragen beantwortet, Inhalte formuliert und echte Aktionen für deine Nutzer ausführt."
      },
      {
        "icon": "Gauge",
        "title": "KPI- & Datenanalysen",
        "body": "Live-Dashboards, die rohe Zahlen in Trends, Alerts und Entscheidungen verwandeln, die dein Team sofort umsetzen kann."
      },
      {
        "icon": "Database",
        "title": "Scraping & Datensammlung",
        "body": "Daten aus Webseiten, anderen Programmen und Dateien einsammeln und in einer sauberen, durchsuchbaren Quelle zusammenführen, der du vertrauen kannst."
      },
      {
        "icon": "Workflow",
        "title": "Intelligente Organisation",
        "body": "Eingehende Elemente automatisch taggen, zuordnen und sortieren, damit nichts verloren geht und dein Team fokussiert bleibt."
      },
      {
        "icon": "Eye",
        "title": "Intelligente Suche & Wissenszugriff",
        "body": "Semantische Suche über jedes Dokument, Ticket und jeden Datensatz — dein Team findet die richtige Antwort in Sekunden, ohne exakte Stichworte."
      },
      {
        "icon": "Feather",
        "title": "Texterstellung & Content-Generierung",
        "body": "E-Mails, Antworten, Zusammenfassungen und Reports automatisch in deinem Ton vorformuliert — bereit zur Freigabe und zum Versand per Klick."
      },
      {
        "icon": "TrendingUp",
        "title": "Prognosen & Anomalie-Erkennung",
        "body": "Nachfrage, Abwanderung und Risiken vorhersagen — und sofort alarmiert werden, sobald eine Kennzahl aus dem Rahmen fällt."
      },
      {
        "icon": "Target",
        "title": "Automatisches Triage & Routing",
        "body": "Eingehende Anfragen lesen, die Absicht verstehen und sie sofort an die richtige Person oder den richtigen Workflow weiterleiten oder eskalieren."
      }
    ],
    "compareKicker": "// im_vergleich",
    "compareTitle": "Aufgeklebte KI vs. KI im Kern",
    "compareLeftLabel": "Aufgeklebter Chatbot",
    "compareRightLabel": "KI im Kern",
    "compareRows": [
      { "label": "Rolle", "left": "Wartet darauf, gefragt zu werden", "right": "Erledigt Arbeit automatisch" },
      { "label": "Dokumente", "left": "Du tippst weiter ab", "right": "Automatisch in saubere Daten umgewandelt" },
      { "label": "Antworten", "left": "Generisch, ohne Kontext", "right": "Auf deinen Daten basierend" },
      { "label": "Reporting", "left": "Manuell, immer zu spät", "right": "Live und proaktiv" },
      { "label": "Daten", "left": "Überall verstreut", "right": "Gesammelt & vereinheitlicht" },
      { "label": "Wert", "left": "Ein Demo-Feature", "right": "Täglich echter Output" }
    ],
    "processKicker": "// wie_wir_bauen",
    "processTitle": "Vom KI-Hype zu KI, die sich auszahlt",
    "steps": [
      { "title": "Die echte Arbeit finden", "body": "Wir kartieren, wo dein Team Stunden verliert — das Tippen, Suchen und Sortieren, das KI wirklich abnehmen kann." },
      { "title": "Den Blueprint entwerfen", "body": "Welche KI-Fähigkeiten, wo sie in deinem Produkt sitzen und die Schutzmaßnahmen, die sie sicher halten." },
      { "title": "Fest einbauen", "body": "Wir bauen die Intelligenz in Sprints in den Kern deiner Software — getestet, kein Gimmick." },
      { "title": "Messen & schärfen", "body": "Wir messen die gesparte Arbeit und tunen die Genauigkeit weiter, damit der Wert über die Zeit wächst." }
    ],
    "faqKicker": "// fragen",
    "faqTitle": "KI in deiner Software — beantwortet",
    "faqs": [
      { "q": "Ist das nur ein ChatGPT-Wrapper?", "a": "Nein. Ein Wrapper beantwortet Fragen; wir bauen KI, die arbeitet — Dokumente in saubere Daten umwandelt, Live-Analysen erzeugt, Daten sammelt und vereinheitlicht, über alles hinweg sucht, Prognosen erstellt, Texte formuliert und Aufgaben automatisch zuordnet. Der Chatbot ist nur eine von neun Fähigkeiten, und selbst er basiert auf deinen eigenen Daten." },
      { "q": "Sind unsere Daten sicher, wenn ihr KI einbaut?", "a": "Ja. Wir entwerfen mit strengen Schutzmaßnahmen: begrenzter Zugriff, kein Training mit deinen privaten Daten, geprüfte Eingaben und klare Grenzen, was die KI darf und was nicht. Sicherheit ist ab dem Blueprint eingebaut, nicht später aufgesetzt." },
      { "q": "Wie genau ist die KI-Dokumenten- und PDF-Analyse?", "a": "Sehr genau bei klar aufgebauten Dokumenten wie Rechnungen, Verträgen und Reports — und wo Genauigkeit kritisch ist, ergänzen wir eine zusätzliche Prüfung und eine menschliche Kontrolle, für Tempo ohne blindes Vertrauen." },
      { "q": "Könnt ihr KI zu bestehender Software hinzufügen?", "a": "Oft ja. Wir können diese Fähigkeiten in ein bestehendes Produkt integrieren oder in etwas Neues bauen. Wir starten dort, wo Intelligenz den höchsten Mehrwert bringt." },
      { "q": "Wie lange, bis die KI echte Arbeit leistet?", "a": "Eine fokussierte erste Fähigkeit ist meist in wenigen Wochen live. Wir liefern in Inkrementen, sodass du früh echten Output siehst, statt Monate auf einen großen Launch zu warten." }
    ],
    "ctaTitle": "Lass KI arbeiten — kleb sie nicht nur auf.",
    "ctaBody": "Sag uns, wo dein Team am meisten Zeit verliert. Wir zeigen dir genau, wo KI fest in deiner Software echte Arbeit leisten würde."
  },
  {
    "slug": "custom-software-fixed-price",
    "eyebrow": "// festpreis",
    "title": "Eigene Software zum [[Festpreis.]]",
    "subtitle": "Eigene Software bauen lassen klingt teuer und kompliziert. Ist es nicht. Ein Festpreis, vorab vereinbart, und ein fester Ansprechpartner vom ersten Gespräch bis zum Launch – keine Stundensatz-Überraschungen, kein Agentur-Pingpong.",
    "metaTitle": "Eigene Software zum Festpreis – fester Ansprechpartner | DevCore",
    "metaDescription": "Eigene Software klingt teuer und kompliziert? Ist sie nicht. DevCore baut sie zum vorab vereinbarten Festpreis, mit einem festen Ansprechpartner von Anfang bis Launch.",
    "stats": [
      { "value": "€ fix", "label": "Preis vor dem Start vereinbart" },
      { "value": "1", "label": "fester Ansprechpartner, durchgehend" },
      { "value": "0", "label": "Stundensatz-Überraschungen" }
    ],
    "problemKicker": "// die_angst",
    "problemTitle": "Eigene Software hat einen Ruf – und der schreckt ab",
    "problemBody": "Die meisten denken, eigene Software bedeutet ein Budget ohne Obergrenze, ein Projekt, das sich ein Jahr zieht, und ständig wechselnde Fremde, die dein Geschäft nie ganz verstehen. So arbeiten große Agenturen. So arbeiten wir nicht.",
    "problemPoints": [
      "Offene Angebote, die jeden Monat wachsen",
      "Keine Ahnung, was am Ende auf der Rechnung steht",
      "Alle paar Wochen ein neuer Ansprechpartner",
      "Fachchinesisch statt klarer Antworten",
      "Das Gefühl, das sei nur was für große Firmen mit großem Budget"
    ],
    "pillarsKicker": "// so_machen_wirs",
    "pillarsTitle": "Planbar, persönlich und auch für kleinere Unternehmen gedacht",
    "pillars": [
      {
        "icon": "FileText",
        "title": "Ein Festpreis, vorab vereinbart",
        "body": "Bevor wir eine Zeile Code schreiben, bekommst du einen klaren Umfang und einen Festpreis. Du gibst frei – und genau das zahlst du. Kein Stundenzähler im Hintergrund."
      },
      {
        "icon": "Eye",
        "title": "Ein Ansprechpartner, der dich kennt",
        "body": "Du sprichst vom ersten Gespräch bis zum Launch mit derselben Person. Sie kennt dein Geschäft, deine Ziele und dein Projekt – kein Herumreichen, kein ewiges Wiederholen."
      },
      {
        "icon": "Gauge",
        "title": "Klar, nicht kompliziert",
        "body": "Wir übersetzen die Technik in verständliche Sprache und einen einfachen Plan. Du verstehst immer, was gebaut wird, warum und was es kostet."
      },
      {
        "icon": "Rocket",
        "title": "Auf dein Unternehmen zugeschnitten",
        "body": "Wir planen nach deinem echten Bedarf und Budget – schlank starten, Nutzen beweisen, dann wachsen. Eigene Software ist längst nicht mehr nur was für Konzerne."
      }
    ],
    "compareKicker": "// im_vergleich",
    "compareTitle": "Typische Agentur vs. Festpreis mit DevCore",
    "compareLeftLabel": "Typische Agentur",
    "compareRightLabel": "DevCore",
    "compareRows": [
      { "label": "Preis", "left": "Stundenbasis, offen", "right": "Fix, vorab vereinbart" },
      { "label": "Ansprechpartner", "left": "Ständig wechselnd", "right": "Eine Person, durchgehend" },
      { "label": "Budget", "left": "Wächst mitten im Projekt", "right": "Was du freigibst, zahlst du" },
      { "label": "Sprache", "left": "Fachchinesisch", "right": "Klar und verständlich" },
      { "label": "Projektgröße", "left": "Auf große Budgets ausgelegt", "right": "Auf dein Unternehmen zugeschnitten" },
      { "label": "Eigentum", "left": "An sie gebunden", "right": "Der Code gehört dir" }
    ],
    "processKicker": "// so_läuft_es",
    "processTitle": "Von der Idee zum Festpreis – in Tagen, nicht Monaten",
    "steps": [
      { "title": "Kostenloses Erstgespräch", "body": "Erzähl uns, was du brauchst. Wir hören zu und stellen die richtigen Fragen – unverbindlich, ohne Fachchinesisch." },
      { "title": "Festpreis-Angebot", "body": "Du bekommst einen klaren Umfang und einen Festpreis, in verständlicher Sprache, bevor irgendetwas gebaut wird." },
      { "title": "Wir bauen es", "body": "Dein fester Ansprechpartner hält dich jede Woche mit lauffähiger Software auf dem Laufenden." },
      { "title": "Launch & Support", "body": "Wir bringen es live, übergeben dir die Schlüssel und bleiben erreichbar – dieselbe Person, dieselbe Nummer." }
    ],
    "faqKicker": "// fragen",
    "faqTitle": "Software zum Festpreis – beantwortet",
    "faqs": [
      { "q": "Ist eigene Software für ein kleines Unternehmen wirklich bezahlbar?", "a": "Ja, öfter als man denkt. Wir planen nach deinem echten Bedarf und Budget – wir können mit einer fokussierten ersten Version starten, die ihren Nutzen beweist, und dann wachsen. Du zahlst keine Konzern-Agenturpreise." },
      { "q": "Was genau heißt 'Festpreis'?", "a": "Wir vereinbaren Umfang und Preis, bevor eine Zeile Code geschrieben wird. Solange sich der Umfang nicht ändert, ist das der Preis, den du zahlst – kein Stundenzähler, keine Überraschungsrechnung am Ende." },
      { "q": "Was, wenn ich überhaupt nicht technisch bin?", "a": "Perfekt – die meisten unserer Kunden sind das nicht. Du erklärst dein Geschäft in einfachen Worten, wir treffen jede technische Entscheidung und erklären sie verständlich zurück." },
      { "q": "Mit wem habe ich es zu tun?", "a": "Mit einem festen Ansprechpartner, vom ersten Gespräch bis zum Launch und darüber hinaus. Er kennt dein Projekt in- und auswendig, du musst dich nie neu erklären." },
      { "q": "Wie schnell können wir starten?", "a": "Das Erstgespräch kann noch diese Woche stattfinden, und ein Festpreis-Angebot hast du innerhalb weniger Tage. Gebaut wird meist kurz nach deiner Freigabe." }
    ],
    "ctaTitle": "Hol dir einen Festpreis – bevor du dich festlegst.",
    "ctaBody": "Erzähl uns, was du bauen willst. Du bekommst einen klaren Plan und einen Festpreis – unverbindlich und ohne Fachchinesisch.",
    "adLanding": true
  },
  {
    "slug": "your-idea-we-build",
    "eyebrow": "// du_erklärst_wir_bauen",
    "title": "Du hast die Idee. [[Wir haben das Tech-Team.]]",
    "subtitle": "Du musst nicht technisch sein, um Software bauen zu lassen. Du erklärst, was du willst, wir bauen es – klar, planbar und vorhersehbar, ganz ohne eigenes Entwicklerteam.",
    "metaTitle": "Du erklärst, wir bauen – Software ohne Tech-Team | DevCore",
    "metaDescription": "Eine Software-Idee, aber kein Tech-Team? DevCore ist dein Entwicklerteam. Du erklärst es, wir bauen es – klar, planbar und vorhersehbar, ganz ohne technisches Vorwissen.",
    "stats": [
      { "value": "0", "label": "Entwickler, die du einstellen musst" },
      { "value": "1", "label": "Team, das die ganze Technik übernimmt" },
      { "value": "100%", "label": "gehört dir, wenn es fertig ist" }
    ],
    "problemKicker": "// die_lücke",
    "problemTitle": "Eine gute Idee ist nichts wert ohne ein Team, das sie baut",
    "problemBody": "Du siehst genau, was die Software können soll. Das Problem ist die Lücke zwischen der Idee in deinem Kopf und lauffähiger Software – und Entwickler einzustellen, zu führen und zu beurteilen, ob sie gut sind, ist ein Job für sich. Genau den nehmen wir dir ab.",
    "problemPoints": [
      "Kein technischer Mitgründer, keine eigenen Entwickler",
      "Keine Möglichkeit zu beurteilen, ob ein Freelancer wirklich gut ist",
      "Die Idee steckt seit Monaten im Kopf (oder in einer Folie) fest",
      "Angebote, die du nicht bewerten kannst, und Zeitpläne, denen du nicht traust",
      "Die Angst, für etwas zu zahlen, das nie fertig wird"
    ],
    "pillarsKicker": "// das_übernehmen_wir",
    "pillarsTitle": "Du bringst die Vision. Wir bringen den Rest.",
    "pillars": [
      {
        "icon": "Eye",
        "title": "Du erklärst, in einfachen Worten",
        "body": "Keine Spezifikation, keine Diagramme nötig. Du beschreibst, was es können soll, wir machen daraus einen klaren Plan, den du wirklich lesen kannst."
      },
      {
        "icon": "Code2",
        "title": "Wir sind dein Tech-Team",
        "body": "Design, Entwicklung, Infrastruktur, Tests – ein komplettes Senior-Team, ohne Einstellen, Führen oder Gehälter zahlen."
      },
      {
        "icon": "FileText",
        "title": "Klar und planbar",
        "body": "Du bekommst Umfang, Zeitplan und Preis vorab, danach jede Woche lauffähige Software. Du weißt immer, wo das Projekt steht."
      },
      {
        "icon": "Rocket",
        "title": "Vorhersehbar, kein Glücksspiel",
        "body": "Wir bauen in kleinen, sichtbaren Schritten, die du steuern kannst – nie monatelange Funkstille mit Überraschung am Ende."
      }
    ],
    "compareKicker": "// im_vergleich",
    "compareTitle": "Ein Team einstellen vs. uns bauen lassen",
    "compareLeftLabel": "Entwickler einstellen",
    "compareRightLabel": "Du erklärst, wir bauen",
    "compareRows": [
      { "label": "Start", "left": "Suchen, prüfen, führen", "right": "Ein Gespräch genügt" },
      { "label": "Können", "left": "Hoffen, dass sie gut sind", "right": "Erprobtes Senior-Team" },
      { "label": "Kosten", "left": "Gehälter & Nebenkosten", "right": "Ein vereinbarter Preis" },
      { "label": "Deine Rolle", "left": "Entwickler managen", "right": "Nur erklären & freigeben" },
      { "label": "Risiko", "left": "Trägst du allein", "right": "Tragen wir mit dir" },
      { "label": "Ergebnis", "left": "Falls es fertig wird", "right": "Fertige Software, die dir gehört" }
    ],
    "processKicker": "// so_läuft_es",
    "processTitle": "Von 'Ich hab da eine Idee' zu fertiger Software",
    "steps": [
      { "title": "Erzähl uns die Idee", "body": "Ein lockeres Erstgespräch, in dem du erklärst, was du willst – in Alltagssprache, ohne Technik." },
      { "title": "Wir planen es", "body": "Wir machen daraus einen klaren Blueprint: was es kann, wie lange, was es kostet. Du gibst frei." },
      { "title": "Wir bauen es", "body": "Deine Software entsteht in wöchentlichen Schritten, die du sehen, testen und mitgestalten kannst." },
      { "title": "Es gehört dir", "body": "Wir bringen es live, übergeben es dir und bleiben da, um es zu betreuen und auszubauen." }
    ],
    "faqKicker": "// fragen",
    "faqTitle": "Du erklärst, wir bauen – beantwortet",
    "faqs": [
      { "q": "Ich bin überhaupt nicht technisch. Ist das ein Problem?", "a": "Überhaupt nicht – bei uns ist das der Normalfall. Du erklärst deine Idee in einfacher Sprache, wir treffen jede technische Entscheidung und halten dich in Worten auf dem Laufenden, die du verstehst." },
      { "q": "Muss ich eine Spezifikation oder ein Lastenheft schreiben?", "a": "Nein. Ein Gespräch reicht zum Start. Wir machen aus dem, was du uns erzählst, einen klaren Blueprint und verfeinern ihn mit dir – du musst die Fachbegriffe nicht kennen." },
      { "q": "Woher weiß ich, dass die Software wirklich gebaut wird?", "a": "Weil du sie jede Woche wachsen siehst, nicht erst am Ende. Wir bauen in kleinen, sichtbaren Schritten, der Fortschritt ist echt und du musst nie raten." },
      { "q": "Gehört sie mir, oder sind wir an euch gebunden?", "a": "Sie gehört vollständig dir – der Code, die Daten, alles. Wir betreuen sie gern weiter, wenn du willst, aber du bist nie gebunden." },
      { "q": "Was kostet es und wie lange dauert es?", "a": "Du bekommst Preis und Zeitplan vorab, bevor wir bauen. Eine fokussierte erste Version ist meist in wenigen Wochen live." }
    ],
    "ctaTitle": "Erzähl uns die Idee. Um die Technik kümmern wir uns.",
    "ctaBody": "Beschreib die Software, die du dir wünschst. Wir machen daraus einen klaren Plan – und dann die echte Sache.",
    "adLanding": true
  }
,
  {
    "slug": "custom-software-development",
    "eyebrow": "// built_for_you",
    "title": "Individualsoftware entwickeln lassen – [[genau für deine Prozesse.]]",
    "subtitle": "Standardsoftware zwingt dein Unternehmen zur Anpassung. Individuelle Softwareentwicklung macht das Gegenteil: Jede Maske, jede Regel und jede Schnittstelle folgt deinen Abläufen – und das Ergebnis gehört dir.",
    "metaTitle": "Individualsoftware entwickeln lassen – individuelle Softwareentwicklung | DevCore",
    "metaDescription": "Individualsoftware entwickeln lassen, die exakt zu deinen Prozessen passt: Webanwendungen, Portale, CRM und interne Tools. Transparente Preisspannen, klares Pflichtenheft, vollständiges Eigentum.",
    "stats": [
      { "value": "3-16", "label": "Wochen bis zum Livegang, je nach Projektart" },
      { "value": "100%", "label": "Eigentum an Code & Daten" },
      { "value": "0", "label": "Lizenzkosten pro Nutzer" }
    ],
    "problemKicker": "// the_gap",
    "problemTitle": "Standardsoftware deckt 70 % ab. Die restlichen 30 % kosten dich täglich Zeit.",
    "problemBody": "Excel-Listen neben dem CRM. Copy-Paste zwischen fünf Tools. Ein Prozess, der nur funktioniert, weil eine Person alle Workarounds kennt. Das ist kein Schulungsproblem – die Software passt einfach nicht zum Unternehmen.",
    "problemPoints": [
      "Doppelte Datenerfassung zwischen Systemen, die nicht miteinander sprechen",
      "Prozesse, die an das Tool angepasst werden statt umgekehrt",
      "Reporting dauert Stunden, weil die Daten an fünf Orten liegen",
      "Lizenzkosten, die mit jedem neuen Mitarbeiter steigen",
      "Kritisches Wissen steckt in Tabellen und Postfächern"
    ],
    "pillarsKicker": "// what_you_get",
    "pillarsTitle": "Individuelle Softwarelösungen, die dein Unternehmen abbilden",
    "pillars": [
      {
        "icon": "Workflow",
        "title": "Deine Prozesse 1:1",
        "body": "Wir modellieren, wie dein Unternehmen wirklich arbeitet – Rollen, Freigaben, Sonderfälle – statt es in eine Vorlage zu pressen."
      },
      {
        "icon": "Boxes",
        "title": "Angebunden an deinen Stack",
        "body": "ERP, CRM, Buchhaltung, DATEV, E-Mail, Lager – das neue System hängt sich an das, was du schon nutzt. Daten werden einmal erfasst."
      },
      {
        "icon": "FileText",
        "title": "Klares Pflichtenheft, planbarer Preis",
        "body": "In der Konzeptphase klären wir Anforderungen, Rollen und Schnittstellen im Detail. Danach stehen Leistungsbeschreibung, Zeitplan und Preis fest – bevor die Entwicklung startet."
      },
      {
        "icon": "Lock",
        "title": "Alles gehört dir",
        "body": "Quellcode, Daten, Infrastruktur. Kein Lock-in, keine Preise pro Arbeitsplatz, kein Anbieter, der deine Roadmap bestimmt."
      }
    ],
    "compareKicker": "// side_by_side",
    "compareTitle": "Standardsoftware vs. Individualsoftware",
    "compareLeftLabel": "Standard-Tool",
    "compareRightLabel": "Individualsoftware",
    "compareRows": [
      { "label": "Passung zum Prozess", "left": "Du passt dich an", "right": "Die Software passt sich an" },
      { "label": "Kostenmodell", "left": "Pro Nutzer, dauerhaft", "right": "Einmalige Investition" },
      { "label": "Schnittstellen", "left": "Was angeboten wird", "right": "Was du brauchst" },
      { "label": "Daten", "left": "Auf fremder Plattform", "right": "Bei dir" },
      { "label": "Roadmap", "left": "Entscheidet ein anderer", "right": "Entscheidest du" },
      { "label": "Wachstum", "left": "Wird teurer", "right": "Wird wertvoller" }
    ],
    "processKicker": "// how_we_build",
    "processTitle": "Von der Anforderung zum laufenden System",
    "steps": [
      { "title": "Kostenloser Blueprint", "body": "Beschreib deine Idee – du bekommst Roadmap, Techstack und ein grobes Pflichtenheft, kostenlos." },
      { "title": "Konzeptphase & Festpreis", "body": "Gemeinsam klären wir Abläufe, Rollen und Schnittstellen im Detail. Daraus entsteht eine verbindliche Leistungsbeschreibung mit Zeitplan und Festpreis." },
      { "title": "Entwicklung in Sprints", "body": "Alle zwei Wochen siehst du lauffähige Software und kannst mitsteuern." },
      { "title": "Livegang & Ausbau", "body": "Erst live, dann Modul für Modul erweitern, wie das Geschäft wächst." }
    ],
    "faqKicker": "// questions",
    "faqTitle": "Individualsoftware entwickeln lassen – häufige Fragen",
    "faqs": [
      {
        "q": "Was kostet Individualsoftware?",
        "a": "Das hängt vom Umfang ab. Typische Spannen: interne Tools ab ca. 15.000 €, Kundenportale 30.000–55.000 €, individuelle CRMs 35.000–70.000 €, SaaS-Plattformen (MVP) 50.000–95.000 €. Einen verbindlichen Festpreis nennen wir nach der gemeinsamen Konzeptphase, wenn der Umfang wirklich feststeht. Alle Spannen findest du auf unserer Kostenseite."
      },
      {
        "q": "Wie lange dauert die Entwicklung?",
        "a": "Kleine Tools gehen meist in drei bis sechs Wochen live, Portale und CRMs in sechs bis 14 Wochen, eine SaaS-Plattform (MVP) in zehn bis 16 Wochen. Wir liefern in Sprints, du arbeitest also früh mit echter Software statt monatelang zu warten."
      },
      {
        "q": "Welche Art von Software entwickelt ihr?",
        "a": "Webanwendungen, Kunden- und Partnerportale, CRM-Systeme, ERP-Erweiterungen, interne Tools, Dashboards, Buchungs- und Angebotssysteme sowie KI-gestützte Workflows."
      },
      {
        "q": "Lässt sich die Software an unsere bestehenden Systeme anbinden?",
        "a": "Ja. Wir integrieren ERP, CRM, Buchhaltung, DATEV, E-Mail, Payment und Lagersysteme per API, damit Daten einmal erfasst und überall genutzt werden."
      },
      {
        "q": "Wem gehört der Quellcode?",
        "a": "Dir – vollständig. Code, Daten und Infrastruktur gehören dir, inklusive Dokumentation. Du bist von keinem Anbieter abhängig."
      },
      {
        "q": "Wie fangen wir an?",
        "a": "Mit dem kostenlosen Blueprint: Beschreib deine Idee in wenigen Sätzen und erhalte Roadmap, Techstack und ein grobes Pflichtenheft. Völlig unverbindlich."
      }
    ],
    "ctaTitle": "Hol dir dein Pflichtenheft – kostenlos.",
    "ctaBody": "Beschreib deine Anforderung in wenigen Sätzen. Du bekommst Roadmap, Techstack und ein grobes Pflichtenheft, mit dem du arbeiten kannst – mit oder ohne uns."
  },

  {
    "slug": "software-development-agency",
    "eyebrow": "// your_partner",
    "title": "Eine Softwareentwicklung-Agentur, die [[liefert – nicht nur präsentiert.]]",
    "subtitle": "Keine Account-Manager zwischen dir und den Entwicklern. Ein kleines Senior-Team, klarer Umfang, Festpreis und alle zwei Wochen lauffähige Software. Das ist das ganze Modell.",
    "metaTitle": "Softwareentwicklung Agentur für Individualsoftware | DevCore",
    "metaDescription": "Softwareentwicklung Agentur für individuelle Unternehmenssoftware: Senior-Team, Festpreis, alle zwei Wochen ein Release. Kostenloser Blueprint zum Start.",
    "stats": [
      { "value": "2", "label": "Wochen pro Release" },
      { "value": "1", "label": "direkter Kontakt, keine Ebenen" },
      { "value": "0", "label": "Überraschungsrechnungen" }
    ],
    "problemKicker": "// the_agency_problem",
    "problemTitle": "Die meisten Agenturprojekte scheitern, bevor die erste Zeile Code steht.",
    "problemBody": "Hochwertiger Pitch, danach Junioren in der Umsetzung. Anforderungen, die sich in Change Requests verwandeln. Budgets, die sich verdoppeln. Das Ergebnis: ein System, für das niemand Verantwortung übernehmen will. Die Lösung ist keine größere Agentur, sondern eine kleinere mit echter Verantwortung.",
    "problemPoints": [
      "Senior-Leute im Pitch, Junioren im Projekt",
      "Jede Rückfrage wird zum kostenpflichtigen Change Request",
      "Monate Funkstille, dann eine Demo, die am Ziel vorbeigeht",
      "Nach Projektende kann niemand den Code erklären",
      "Abrechnung nach Stunden – ohne Obergrenze"
    ],
    "pillarsKicker": "// how_we_work",
    "pillarsTitle": "So sieht die Zusammenarbeit wirklich aus",
    "pillars": [
      {
        "icon": "Target",
        "title": "Direkt mit den Entwicklern",
        "body": "Du sprichst mit den Menschen, die den Code schreiben. Keine Account-Ebene, kein Flüsterspiel, kein Kontextverlust."
      },
      {
        "icon": "FileText",
        "title": "Pflichtenheft und Festpreis",
        "body": "Umfang, Zeitplan und Preis stehen vorab fest. Änderungen besprechen wir offen, statt sie als Change Request auszuspielen."
      },
      {
        "icon": "Gauge",
        "title": "Alle 2 Wochen lauffähige Software",
        "body": "Du klickst den Fortschritt laufend durch und kannst früh korrigieren – im günstigsten Moment für jede Änderung."
      },
      {
        "icon": "ShieldCheck",
        "title": "Übergabe statt Abhängigkeit",
        "body": "Dokumentierter Code, deine Repositories, deine Infrastruktur. Du kannst mit uns, intern oder woanders weitermachen."
      }
    ],
    "compareKicker": "// side_by_side",
    "compareTitle": "Klassische Agentur vs. DevCore",
    "compareLeftLabel": "Klassische Agentur",
    "compareRightLabel": "DevCore",
    "compareRows": [
      { "label": "Ansprechpartner", "left": "Account-Manager", "right": "Die Entwickler" },
      { "label": "Abrechnung", "left": "Stundenbasis, offen", "right": "Festpreis, vorab" },
      { "label": "Team", "left": "Seniors pitchen, Junioren bauen", "right": "Seniors bauen" },
      { "label": "Fortschritt", "left": "Meilenstein-Demos", "right": "Alle zwei Wochen" },
      { "label": "Code", "left": "Ihr Repo, ihre Regeln", "right": "Deins, dokumentiert" },
      { "label": "Änderungen", "left": "Change Request", "right": "Gespräch" }
    ],
    "processKicker": "// engagement",
    "processTitle": "So läuft ein Projekt bei uns",
    "steps": [
      { "title": "Kostenloser Blueprint", "body": "Du beschreibst das Projekt, wir liefern Roadmap, Techstack und ein grobes Pflichtenheft." },
      { "title": "Erstgespräch", "body": "30 Minuten zu Machbarkeit, Risiken und dem, was wir anders machen würden." },
      { "title": "Festes Angebot", "body": "Verbindlicher Umfang, Zeitplan und Preis – du entscheidest mit allen Informationen." },
      { "title": "Umsetzung & Übergabe", "body": "Releases alle zwei Wochen, danach dokumentierte Übergabe und optionaler Support." }
    ],
    "faqKicker": "// questions",
    "faqTitle": "Zusammenarbeit mit einer Software-Agentur – häufige Fragen",
    "faqs": [
      {
        "q": "Welche Projekte übernehmt ihr?",
        "a": "Individuelle Unternehmenssoftware: Webanwendungen, Kunden- und Partnerportale, CRM-Systeme, interne Tools, Schnittstellen und KI-gestützte Workflows. Typischerweise für Unternehmen mit 10 bis 500 Mitarbeitenden."
      },
      {
        "q": "Arbeitet ihr remote oder vor Ort?",
        "a": "Überwiegend remote mit festen, regelmäßigen Terminen. Workshops vor Ort sind für Kick-off oder komplexe Prozessaufnahmen möglich."
      },
      {
        "q": "Wie geht ihr mit sich ändernden Anforderungen um?",
        "a": "Anforderungen ändern sich immer. Wir planen in Sprints, damit Änderungen im nächsten Sprint landen statt in einer Vertragsdiskussion."
      },
      {
        "q": "Was passiert nach dem Livegang?",
        "a": "Du entscheidest: Support- und Weiterentwicklungsvereinbarung oder vollständige Übergabe mit Dokumentation, damit dein Team allein weiterarbeitet."
      },
      {
        "q": "Warum ist ein kleines Team ein Vorteil?",
        "a": "Weniger Übergaben, keine internen Eskalationswege, Senior-Leute an der eigentlichen Arbeit. Deshalb dauert ein erstes Release Wochen statt Quartale."
      }
    ],
    "ctaTitle": "Lass uns dein Projekt ansehen – kostenlos.",
    "ctaBody": "Beschreib, was du bauen willst. Du bekommst Roadmap, Techstack und ein grobes Pflichtenheft zurück – danach entscheidest du, ob wir es umsetzen."
  }
];
